/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Event_user = {
    readonly emails: ReadonlyArray<string>;
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"EventSummary_user" | "EventSmartHoldInfo_user" | "EventTeam_user" | "AutopilotFormSaveOnEdit_user">;
    readonly " $refType": "Event_user";
};
export type Event_user$data = Event_user;
export type Event_user$key = {
    readonly " $data"?: Event_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Event_user">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Event_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emails",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSummary_user"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSmartHoldInfo_user"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventTeam_user"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AutopilotFormSaveOnEdit_user"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any;
(node as any).hash = 'f703cb13365ab6efd88008e215488540';
export default node;
